import { SalesClient } from '@/renderer/types/order';
import { Edit2, Percent } from 'lucide-react';
import React from 'react';

interface ClientsTableProps {
  clients: SalesClient[];
  onEdit: (client: SalesClient) => void;
}

export const ClientsTable: React.FC<ClientsTableProps> = ({
  clients,
  onEdit,
}) => (
  <div className="overflow-hidden rounded-2xl border border-gray-200 bg-white">
    <div className="max-h-[70vh] overflow-auto">
      <table className="w-full min-w-[880px]">
        <thead className="sticky top-0 z-10 bg-app-bg">
          <tr className="border-b border-gray-200 text-xs uppercase tracking-wide text-gray-600">
            <th className="px-5 py-3 text-left">Client</th>
            <th className="px-5 py-3 text-left">Email</th>
            <th className="px-5 py-3 text-left">Contact</th>
            <th className="px-5 py-3 text-left">Address</th>
            <th className="px-5 py-3 text-left">TIN</th>
            <th className="px-5 py-3 text-right">Menu Rate</th>
            <th className="px-5 py-3 text-right">Actions</th>
          </tr>
        </thead>
        <tbody>
          {clients.map((client) => (
            <tr
              key={client.id}
              className="border-b border-gray-100 last:border-b-0"
            >
              <td className="px-5 py-4 align-top">
                <p className="font-semibold text-black">{client.full_name}</p>
              </td>
              <td className="px-5 py-4 align-top text-sm text-gray-700">
                {client.email || '—'}
              </td>
              <td className="px-5 py-4 align-top text-sm text-gray-700">
                {client.contact || '—'}
              </td>
              <td className="px-5 py-4 align-top text-sm text-gray-700">
                {client.address || '—'}
              </td>
              <td className="px-5 py-4 align-top text-sm text-gray-700">
                {client.tin_number || '—'}
              </td>
              <td className="px-5 py-4 align-top text-right text-sm font-medium text-black">
                <span className="inline-flex items-center gap-1">
                  <Percent size={14} className="text-gray-400" />
                  {client.menu_percentage_rate ?? 0}
                </span>
              </td>
              <td className="px-5 py-4 align-top text-right">
                <button
                  type="button"
                  onClick={() => onEdit(client)}
                  className="rounded-lg p-1.5 text-gray-400 transition-colors hover:bg-gray-100 hover:text-gray-600"
                  title="Edit client"
                >
                  <Edit2 size={14} />
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </div>
);
